const initialState = {
    selectedProject: null,
};

export const projectsReducer = (state = initialState, action) => {
    switch (action.type) {

        case "SET_SELECTED_PROJECT":
            return {
                ...state,
                selectedProject: action.payload,
            };

        default:
            return state;
    }
};